import cookies from './util.cookies'
import log from './util.log'
import db from './util.db';

const util = {
  cookies,
  log,
  db
}

export default util
